module.exports = "/assets/data/af41f09eab26918f21f418e2a10dac0e-SL6.data.json";